"use strict";

require("core-js/modules/es6.object.keys.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.array.filter.js");

require("core-js/modules/es6.object.get-own-property-descriptor.js");

require("core-js/modules/es7.object.get-own-property-descriptors.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.promise.js");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactDropzone = _interopRequireDefault(require("react-dropzone"));

require("../../../../sass/components/shared/elements/imageUpload/ImageDropzone.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var getImgWidthHeight = function getImgWidthHeight(src) {
  return new Promise(function (resolve, reject) {
    var img = new Image();

    img.onload = function () {
      return resolve({
        height: img.height,
        width: img.width
      });
    };

    img.onerror = reject;
    img.src = src;
  });
};

var _default = function _default(_ref) {
  var handleDrop = _ref.handleDrop,
      v3Styling = _ref.v3Styling,
      v11Styling = _ref.v11Styling,
      v11InviteStyling = _ref.v11InviteStyling,
      _ref$defaultIcon = _ref.defaultIcon,
      defaultIcon = _ref$defaultIcon === void 0 ? true : _ref$defaultIcon,
      _ref$uploadIcon = _ref.uploadIcon,
      uploadIcon = _ref$uploadIcon === void 0 ? '' : _ref$uploadIcon,
      title = _ref.title,
      subtitle = _ref.subtitle,
      buttonText = _ref.buttonText,
      _ref$minWidth = _ref.minWidth,
      minWidth = _ref$minWidth === void 0 ? 300 : _ref$minWidth,
      _ref$minHeight = _ref.minHeight,
      minHeight = _ref$minHeight === void 0 ? 200 : _ref$minHeight,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? true : _ref$multiple;
  var selectButtonText = global.window && window.innerWidth >= 768 ? 'Upload from files' : 'Upload a photo';
  var dropzoneClasses = (0, _classnames.default)('dropzone-body', {
    'v3-styling': v3Styling,
    'v11-styling': v11Styling,
    'v11-invite-styling': v11InviteStyling,
    'default-icon': defaultIcon
  });

  var onDrop = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var files,
          file,
          _yield$getImgWidthHei,
          _yield$getImgWidthHei2,
          height,
          _yield$getImgWidthHei3,
          width,
          _args = arguments;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              files = _args.length > 0 && _args[0] !== undefined ? _args[0] : [{}];
              file = files[0] || {};
              _context.next = 4;
              return getImgWidthHeight(file.preview);

            case 4:
              _yield$getImgWidthHei = _context.sent;
              _yield$getImgWidthHei2 = _yield$getImgWidthHei.height;
              height = _yield$getImgWidthHei2 === void 0 ? 0 : _yield$getImgWidthHei2;
              _yield$getImgWidthHei3 = _yield$getImgWidthHei.width;
              width = _yield$getImgWidthHei3 === void 0 ? 0 : _yield$getImgWidthHei3;
              if (width < minWidth || height < minHeight) alert("The photo must be at least ".concat(minWidth, "px by ").concat(minHeight, "px. It seems your photo does not meet these requirements. Your photo is ").concat(width, "px by ").concat(height, "px"));else handleDrop(files);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onDrop() {
      return _ref2.apply(this, arguments);
    };
  }();

  var acceptFileExtensions = 'image/jpeg, image/png, image/gif, image/webp, image/tiff, image/raw, image/bmp, image/heif, image/jpeg2000';
  return /*#__PURE__*/_react.default.createElement(_reactDropzone.default, {
    onDrop: onDrop,
    multiple: multiple,
    className: dropzoneClasses,
    accept: acceptFileExtensions
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dropzone-icon",
    style: _objectSpread({}, !defaultIcon && uploadIcon && {
      backgroundImage: "url('".concat(uploadIcon, "')")
    })
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "dropzone-text"
  }, title || 'Drag & drop your image here or'), subtitle && /*#__PURE__*/_react.default.createElement("span", {
    className: "dropzone-subtitle"
  }, subtitle), /*#__PURE__*/_react.default.createElement("div", {
    className: "dropzone-select-button"
  }, buttonText || selectButtonText));
};

exports.default = _default;